var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "header",
    { staticClass: "header" },
    [
      _c(_setup.NavigationLogo),
      _vm._v(" "),
      _c(
        "nav",
        { staticClass: "nav" },
        _vm._l(_vm.$store.state.menu, function (item) {
          return _c(_setup.NavigationItem, {
            key: item._uid,
            attrs: { item: item },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }